import { render, staticRenderFns } from "./ProjectBriefList.vue?vue&type=template&id=32966670&scoped=true&"
import script from "./ProjectBriefList.vue?vue&type=script&lang=js&"
export * from "./ProjectBriefList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectBriefList.vue?vue&type=style&index=0&id=32966670&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32966670",
  null
  
)

export default component.exports